import { Loader } from '@googlemaps/js-api-loader';
import {
    mapElement,
    map,
    markerMode,
    infowindow,
    infowindowTimeout,
    setMap,
    setMarkerMode,
    setInfowindow,
    setInfowindowTimeout,
    clusters,
} from './map/_context.js';
import { applyMapPadding, syncFullscreenToggleButtons } from './map/_map-view.js';
import { closeInfoWindow } from './map/_infowindow.js';
import {
    redoMarkers,
    attachMapSidebarHandlers,
    closePin,
    focusOpenPinFromUrlIfNeeded,
} from './map/_markers.js';
import {
    applyCategoryFiltersFromUrl,
    expandSidePanelUiForActiveFilters,
    syncCategoryHistoryReplace,
} from './map/_category-history.js';
import { initHtmlMarkerClass } from './map/_html-marker.js';

function applyOpenPinFromUrl() {
    if (!mapElement || !mapElement[0]) {
        return;
    }
    if (mapElement[0].getAttribute('data-open-pin')) {
        return;
    }
    try {
        const params = new URLSearchParams(window.location.search);
        const pin = params.get('lieu');
        if (!pin) {
            return;
        }
        const trimmed = pin.trim();
        if (/^\d+$/.test(trimmed)) {
            mapElement[0].setAttribute('data-open-pin', trimmed);
            return;
        }
        if (typeof actMapData !== 'undefined' && Array.isArray(actMapData)) {
            const item = actMapData.find(function (e) {
                return e.slug && String(e.slug) === trimmed;
            });
            if (item) {
                mapElement[0].setAttribute('data-open-pin', String(item.id));
            }
        }
    } catch (e) {
        /* ignore */
    }
}

attachMapSidebarHandlers();

document.addEventListener('click', function (event) {
    const fsBtn = event.target.closest('.js-toggle-fullscreen');
    if (fsBtn) {
        document.querySelector('.carte-layout').classList.toggle('carte-layout--fullscreen');
        syncFullscreenToggleButtons();
    }
});

if (mapElement) {
    Array.prototype.forEach.call(mapElement, creationGMapElement);
}

function creationGMapElement(el) {
    if (!document.getElementsByTagName('body')[0].getAttribute('data-additionnal-categ')) {
        document.getElementsByTagName('body')[0].setAttribute('data-additionnal-categ', '');
    }
    const lat = 46;
    const lng = -73;
    const lang = el.getAttribute('data-lang');
    const key = el.getAttribute('data-key');
    const mapId = el.getAttribute('data-map-id');
    let loader;
    try {
        loader = new Loader({
            apiKey: key,
            version: 'weekly',
            language: lang.substring(0, 2),
            libraries: ['marker'],
        });
    } catch (error) {
        location.reload();
    }
    loader.load().then(() => {
        initHtmlMarkerClass();
        var reclat = 0.0004;
        var reclng = 0.000;
        const mapOptions = {
            center: { lat: lat + reclat, lng: lng + reclng },
            zoom: 10,
            language: lang,
            streetViewControl: false,
            mapTypeControl: mapTypeControl,
            fullscreenControl: false,
            gestureHandling: 'greedy',
            styles: actMapStyles,
        };
        if (mapId) {
            mapOptions.mapId = mapId;
        }
        setMap(new google.maps.Map(document.getElementById(el.getAttribute('id')), mapOptions));

        map.addListener('mapcapabilities_changed', () => {
            const mapCapabilities = map.getMapCapabilities();
            const newMode = mapCapabilities.isAdvancedMarkersAvailable ? 'advanced' : 'basic';
            if (newMode !== markerMode) {
                setMarkerMode(newMode);
                actMapData.forEach((item) => {
                    if (item.marker) {
                        try {
                            item.marker.setMap(null);
                        } catch (err) {}
                        delete item.marker;
                    }
                    if (item.htmlMarker) {
                        item.htmlMarker.setMap(null);
                        delete item.htmlMarker;
                    }
                });
                if (clusters) {
                    clusters.clearMarkers();
                }
                redoMarkers();
            }
        });

        setInfowindow(
            new google.maps.InfoWindow({
                content: '',
            }),
        );

        const mapInitEvent = new CustomEvent('actMap:initialized', {
            detail: {
                map: map,
                mapElement: el,
                infowindow: infowindow,
            },
        });
        document.dispatchEvent(mapInitEvent);

        applyMapPadding();
        window.addEventListener('resize', applyMapPadding);

        google.maps.event.addListener(infowindow, 'domready', function () {
            document.querySelector('.infowindow').addEventListener('mouseover', function (e) {
                if (!e.currentTarget.classList.contains('infowindow--active')) {
                    clearTimeout(infowindowTimeout);
                }
            });
            document.querySelector('.infowindow').addEventListener('mouseout', function (e) {
                if (!e.currentTarget.classList.contains('infowindow--active')) {
                    setInfowindowTimeout(setTimeout(closeInfoWindow, 250));
                }
            });
            document.querySelector('.infowindow .js-close-data-panel').addEventListener('click', closePin);
        });

        /** After Maps loader resolves: footer scripts (VirtualSelect, etc.) have run — `setValue` exists for URL filters. */
        applyCategoryFiltersFromUrl();
        expandSidePanelUiForActiveFilters();
        applyOpenPinFromUrl();

        redoMarkers();
        syncCategoryHistoryReplace();
        focusOpenPinFromUrlIfNeeded();

        window.setTimeout(function () {
            let initForceCenterArray = initForceCenter.split(',');
            if (initForceCenterArray.length == 2) {
                map.setCenter({
                    lat: parseFloat(initForceCenterArray[0]),
                    lng: parseFloat(initForceCenterArray[1]),
                });
            }
            if (initForceZoom != '') {
                map.setZoom(parseInt(initForceZoom));
            }
        }, 300);
    });
}
